import ColorPicker from './colorPicker';

export default ColorPicker;